"use client";
import React from "react";
import Button from "antd/es/button";
import Typography from "antd/es/typography";
import ConsultationDrawer from "./ConsultationDrawer";
import type {
  ConsultationService,
  ServiceRequestPayload,
} from "./ServiceRequestForm";
import type { MediaUploadFn } from "./ServiceRequestForm/Uploader";
import type { ScheduleSummary } from "./LocationStep";

const { Paragraph } = Typography;

/**
 * Inline "consultation required" panel with a drawer for the request form.
 *
 * Shows the list of services requiring consultation, a "Send a request" button,
 * and opens ConsultationDrawer when clicked.
 */
const ServiceConsultation = ({
  salonId,
  userId,
  teamMemberId,
  scheduleId,
  scheduleOptions,
  services,
  submitRequest,
  uploadMedia,
}: {
  salonId: string;
  userId?: string;
  teamMemberId?: string;
  scheduleId?: string;
  scheduleOptions?: ScheduleSummary[];
  services: ConsultationService[];
  submitRequest: (payload: ServiceRequestPayload) => Promise<void>;
  uploadMedia: MediaUploadFn;
}) => {
  const [isRequestFormActive, setRequestFormActive] = React.useState(false);

  return (
    <>
      <Paragraph>
        The following services require a consultation before booking. Please
        submit a request form to schedule one:
      </Paragraph>
      <Paragraph>
        <ul
          style={{
            listStyleType: "square",
            color: "var(--openings-booking-skin-text, black)",
          }}
        >
          {services.map((service) => (
            <li key={service.title}>{service.title}</li>
          ))}
        </ul>
      </Paragraph>

      <Button block onClick={() => setRequestFormActive(true)} type="primary">
        Send a request
      </Button>

      <ConsultationDrawer
        salonId={salonId}
        userId={userId}
        teamMemberId={teamMemberId}
        scheduleId={scheduleId}
        scheduleOptions={scheduleOptions}
        services={services}
        open={isRequestFormActive}
        onClose={() => setRequestFormActive(false)}
        submitRequest={submitRequest}
        uploadMedia={uploadMedia}
      />
    </>
  );
};

export default ServiceConsultation;
